<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/start.png">
    <div class="button-container">
      <router-link class="button" to="/work">Starten</router-link>
    </div>
  </div>
</template>

<style scoped>
.home{width: 100%; height:calc(100vh - 80px); max-width:100%;}
img{display:block; width: 100%;  height: 100%;  object-fit: cover; }
a{display:inline-block;}
.button-container{position:absolute; top: auto; bottom: 10%; display:flex; justify-content: center; gap: 1em;width: 100%;}
</style>
